import Vue from "vue";
import Router from "vue-router";

// 引入页面
import Home from "../views/Home";
import Index from "../views/LoadIndex";
import Login from "../views/Login";
import LoginSuccess from "../views/login/WxLoginSuccess";
import moHome from "../mobile/moHome";
// import childContent from "../components/Layout/childContent"

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);

// 配置路由
const router = new Router({
  //mode: 'history',
  routes: [
    {
      path: "/",
      redirect: "/home"
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      hidden: true,
      meta: {
        title: "云呵护登录",
        notLogin: true
      }
    },
    {
      path: "/error",
      name: "error",
      component: () => import("@/views/err"),
      hidden: true,
      meta: {
        title: "出错了",
        notLogin: true
      }
    },
    {
      path: "/first",
      component: Index,
      hidden: true,
      meta: {
        title: "加载中"
      }
    },
    {
      path: "/loginSuccess",
      component: LoginSuccess,
      hidden: true,
      meta: {
        title: "登录中...",
        notLogin: true
      }
    },
    {
      path: "/homeTop",
      name: "home",
      component: Home,
      meta: {
        title: "首页"
      },
      children: [
        {
          path: "/home",
          // name: "home",
          component: () => import("@/views/home/allInfo/Index"),
          meta: {
            title: "幼儿园数据汇总",
            style: "sy",
            icon: "sy"
          }
        },
        {
          path: "/calendar",
          name: "calendar",
          component: () => import("@/views/home/calendar/index"),
          meta: {
            title: "日历"
          }
        },
        {
          path: "/archivesYear",
          name: "archivesYear",
          component: () => import("@/views/home/archivesYear/StuIndex"),
          meta: {
            title: "年度档案"
          }
        },
        {
          path: "/archivesYearMonth",
          name: "archivesYearMonth",
          component: () => import("@/views/home/archivesYear/StuIndexMonth"),
          meta: {
            title: "年度档案"
          }
        },
        {
          path: "/studentFiles",
          name: "studentFiles",
          component: () => import("@/views/home/studentFiles/index"),
          meta: {
            title: "毕业生档案"
          }
        },
        {
          path: "/nursery",
          name: "nursery",
          component: () => import("@/views/home/nursery/index"),
          meta: {
            title: "AI托育"
          }
        },
      ]
    },
    {
      path: "/ai",
      name: "ai",
      component: Home,
      hidden: true,
      meta: {
        title: "智能助手"
      },
      children: [{
        path: "index",
        name: "aiIndex",
        component: () => import("@/views/AI/index"),
        meta: {
          title: "智能助手"
        }
      }, {
        path: "history",
        name: "history",
        component: () => import("@/views/AI/history"),
        meta: {
          title: "智能助手",
          keepAlive: true,
        }
      }, {
        path: "detail",
        name: "detail",
        component: () => import("@/views/AI/detail"),
        meta: {
          title: "智能助手"
        }
      },]
    },
    {
      path: "/ai/attendance",
      name: "attendance",
      component: () => import("@/views/AI/attendance"),
      meta: {
        title: "考勤管理"
      },
    },
    {
      path: "/humanResources",
      name: "humanResources",
      component: Home,
      meta: {
        title: "人力资源管理"
      },
      children: [
        {
          path: "/teacherManage",
          name: "teacherManage",
          component: () => import("@/views/humanResources/teacherManage/Index"),
          meta: {
            title: "教师管理"
          }
        },
        {
          path: "/teacherAttendance",
          name: "teacherAttendance",
          component: () =>
            import("@/views/humanResources/teacherAttendance/index"),
          meta: {
            title: "教师考勤"
          }
        },
        //  {
        //   path: '',
        //   name: '',
        //   components: () => import('@/views/humanResources'),
        //   meta: {
        //     title: '教师考核'
        //   }
        // }
        {
          path: "/teacherSchedule",
          name: "teacherSchedule",
          component: () =>
            import("@/views/humanResources/teacherSchedule/index"),
          meta: {
            title: "考勤组设置"
          }
        },
        {
          path: "/teacherSetTimes",
          name: "teacherSetTimes",
          component: () =>
            import("@/views/humanResources/teacherSchedule/TeacherSetTimes"),
          meta: {
            title: "教师排班"
          }
        },
        {
          path: "/schoolSchedule",
          name: "schoolSchedule",
          component: () =>
            import("@/views/humanResources/schoolSchedule/index"),
          meta: {
            title: "考勤班次设置"
          }
        }
      ]
    },
    {
      path: "/escalation",
      name: "escalation",
      component: Home,
      meta: {
        title: "上报管理"
      },
      children: [
        {
          path: "/absence",
          name: "absence",
          component: () => import("@/views/escalation/absence/Index"),
          meta: {
            title: "缺勤登记"
          }
        }
      ]
    },
    {
      path: "/attendanceManage",
      name: "attendanceManage",
      component: Home,
      meta: {
        title: "出勤管理",
        keepAlive: false
      },
      children: [
        {
          path: "/leave",
          name: "leave",
          component: () => import("@/views/attendance/leave/Index"),
          meta: {
            title: "请假管理",
            showKq: true,
          }
        },
        {
          path: "/LeaveStudent",
          name: "LeaveStudent",
          component: () => import("@/views/attendance/leave/LeaveStudent"),
          meta: {
            title: "请假详情"
          }
        },
        {
          path: "/dropOut",
          name: "dropOut",
          component: () => import("@/views/attendance/dropOut/Index"),
          meta: {
            title: "休学管理"
          }
        },
        {
          path: "/diligent",
          name: "diligent",
          component: () => import("@/views/attendance/diligent/Index"),
          meta: {
            title: "考勤管理",
            showKq: true,
          }
        },
        {
          path: "/diligentDetails",
          name: "diligentDetails",
          component: () => import("@/views/attendance/diligent/Details"),
          meta: {
            title: "考勤详情"
          }
        },
        {
          path: "/statistics",
          name: "statistics",
          component: () => import("@/views/attendance/statistics/Items"),
          meta: {
            title: "统计分析",
            showKq: true,
          }
        },
        {
          path: "/backGarden",
          name: "backGarden",
          component: () => import("@/views/attendance/backGarden/index"),
          meta: {
            title: "返园管理"
          }
        },
        {
          path: "/weekLeaveChart",
          name: "weekLeaveChart",
          component: () => import("@/views/attendance/weekLeaveChart/index"),
          meta: {
            title: "周请假趋势表",
            keepAlive: true
          }
        },
        {
          path: "/teacherLeave",
          name: "teacherLeave",
          component: () => import("@/views/attendance/teacherLeave/index"),
          meta: {
            title: "教师请假"
          }
        }
      ]
    },
    {
      path: "/morningRecord",
      name: "morningRecord",
      component: Home,
      meta: {
        title: "晨检记录"
      },
      children: [
        {
          path: "/studentMorningCheck",
          name: "studentMorningCheck",
          component: () => import("@/views/morningRecord/studentMorning/Index"),
          meta: {
            title: "学生晨检"
          }
        },
        {
          path: "/teachersMorningCheck",
          name: "teachersMorningCheck",
          component: () =>
            import("@/views/morningRecord/teachersMorning/Index"),
          meta: {
            title: "教师晨检"
          }
        },
        {
          path: "/oneDayThree",
          name: "oneDayThree",
          component: () => import("@/views/morningRecord/oneDayThree/Index"),
          meta: {
            title: "一日三检"
          }
        },
        {
          path: "/morningCheck",
          name: "morningCheck",
          component: () => import("@/views/morningRecord/morningCheck/Index"),
          meta: {
            title: "晨午检全日观察表"
          }
        }
      ]
    },
    {
      path: "/daily",
      name: "daily",
      component: Home,
      meta: {
        title: "日常管理"
      },
      children: [
        {
          path: "/accidentalInjury",
          name: "accidentalInjury",
          component: () => import("@/views/daily/accidental/index"),
          meta: {
            title: "意外伤害管理"
          }
        },
        {
          path: "/disinfect",
          name: "disinfect",
          component: () => import("@/views/daily/disinfect/indexNew"),
          meta: {
            title: "消毒管理",
            keepAlive: true
          }
        },
        {
          path: "/disinfectClass",
          name: "disinfectClass",
          component: () => import("@/views/daily/disinfect/DisinfectDetails"),
          meta: {
            title: "消毒管理-详情"
          }
        },
        {
          path: "/EmergencyInfo",
          name: "EmergencyInfo",
          component: () => import("@/views/daily/disinfect/EmergencyInfo"),
          meta: {
            title: "应急消毒"
          }
        },
        {
          path: "/EmergencyDisinfect",
          name: "EmergencyDisinfect",
          component: () => import("@/views/daily/disinfect/EmergencyDisinfect"),
          meta: {
            title: "应急消毒"
          }
        },
        {
          path: "/EmergencyInfoUpdata",
          name: "EmergencyInfoUpdata",
          component: () =>
            import("@/views/daily/disinfect/EmergencyInfoUpdata"),
          meta: {
            title: "应急消毒"
          }
        },
        {
          path: "/medicine",
          name: "medicine",
          component: () => import("@/views/daily/takeMedicine/Index"),
          meta: {
            title: "服药管理"
          }
        },
        {
          path: "/contagion",
          name: "contagion",
          component: () => import("@/views/daily/contagion/Index"),
          meta: {
            title: "传染病管理"
          }
        },
        {
          path: "/contagionDetails",
          name: "contagionDetails",
          component: () => import("@/views/daily/contagion/Details"),
          meta: {
            title: "传染病统计详情"
          }
        },
        {
          path: "/leavewz",
          name: "leavewz",
          component: () => import("@/views/daily/leavewz/Index"),
          meta: {
            title: "离温申请"
          }
        },
        {
          path: "/leaveKdApply",
          name: "leaveKdApply",
          component: () => import("@/views/daily/leaveKdApply/Index"),
          meta: {
            title: "离园申请"
          }
        },
        {
          path: "/xxNewPestilence",
          name: "xxNewPestilence",
          component: () => import("@/views/daily/xxNewPestilence/index"),
          meta: {
            title: "学生新冠防疫"
          }
        },
        {
          path: "/newCrownDetails",
          name: "newCrownDetails",
          component: () =>
            import("@/views/daily/xxNewPestilence/newCrownDetails"),
          meta: {
            title: "新冠疫苗接种"
          }
        },
        {
          path: "/nucleicAcidDetails",
          name: "nucleicAcidDetails",
          component: () =>
            import("@/views/daily/xxNewPestilence/nucleicAcidDetails"),
          meta: {
            title: "核酸检测"
          }
        },
        {
          path: "/jsNewPestilence",
          name: "jsNewPestilence",
          component: () => import("@/views/daily/jsNewPestilence/Index"),
          meta: {
            title: "教师新冠防疫"
          }
        },
        {
          path: "/questionnaireSurvey",
          name: "questionnaireSurvey",
          component: () => import("@/views/daily/questionnaireSurvey/Index"),
          meta: {
            title: "问卷调查"
          }
        },
        {
          path: "/lunchPatrol",
          name: "lunchPatrol",
          component: () => import("@/views/daily/lunchPatrol/indexNew"),
          meta: {
            title: "午睡巡视"
          }
        },
        {
          path: "/lunchPatrolClass",
          name: "lunchPatrolClass",
          component: () => import("@/views/daily/lunchPatrol/indexLunch"),
          meta: {
            title: "午睡巡视"
          }
        },
        {
          path: "/lunchPatrolInfo",
          name: "lunchPatrolInfo",
          component: () => import("@/views/daily/lunchPatrol/indexTour"),
          meta: {
            title: "午睡巡视"
          }
        },
        {
          path: "/visitPark",
          name: "visitPark",
          component: () => import("@/views/daily/visitPark/index"),
          meta: {
            title: "入园申请"
          }
        },
        {
          path: "/leaveParkInspect",
          name: "leaveParkInspect",
          component: () => import("@/views/daily/leaveParkInspect/indexNew"),
          meta: {
            title: "离园检查"
          }
        },
        {
          path: "/leaveParkInspectClass",
          name: "leaveParkInspectClass",
          component: () => import("@/views/daily/leaveParkInspect/index"),
          meta: {
            title: "离园检查",
            keepAlive: true,
          }
        },
        {
          path: "/leaveParkInspectDetail",
          name: "leaveParkInspectDetail",
          component: () =>
            import("@/views/daily/leaveParkInspect/leaveParkInspect"),
          meta: {
            title: "离园检查"
          }
        },
        {
          path: "/leaveParkSet",
          name: "leaveParkSet",
          component: () =>
            import("@/views/daily/leaveParkInspect/leaveParkSet"),
          meta: {
            title: "离园设置"
          }
        },
        {
          path: "/leaveSetDetail",
          name: "leaveSetDetail",
          component: () =>
            import("@/views/daily/leaveParkInspect/leaveSetDetail"),
          meta: {
            title: "离园设置"
          }
        },
        {
          path: "/exam",
          redirect: "/exam/list/1",
        },
        {
          path: "/exam/list/:status",
          name: "exam",
          component: () => import("@/views/exam/index"),
          meta: {
            title: "问卷调查",
            keepAlive: true,
          }
        },
        {
          path: "/exam/edit/:type",
          name: "examEdit",
          component: () => import("@/views/exam/edit"),
          meta: {
            title: "问卷调查编辑",
          }
        },
        {
          path: "/exam/success",
          name: "success",
          component: () => import("@/views/exam/success"),
          meta: {
            title: "问卷发布",
          }
        },
        {
          path: "/exam/templateList",
          name: "template",
          component: () => import("@/views/exam/templateList"),
          meta: {
            title: "问卷模板",
            keepAlive: true,
          }
        },
        {
          path: "/exam/preview",
          name: "template",
          component: () => import("@/views/exam/preview"),
          meta: {
            title: "问卷预览",
          }
        },
        {
          path: "/exam/submit",
          name: "submit",
          component: () => import("@/views/exam/submit"),
          meta: {
            title: "填写问卷",
          }
        },
        {
          path: "/exam/useDatas",
          redirect: '/exam/useDatas/total'
        },
        {
          path: "/exam/useDatas/:title",
          name: "useDatas",
          component: () => import("@/views/exam/useDatas"),
          meta: {
            title: "统计结果",
          }
        },
      ]
    },
    {
      path: "/dietManagement",
      name: "dietManagement",
      component: Home,
      meta: {
        title: "膳食管理"
      },
      children: [
        {
          path: "/Catering",
          name: "Catering",
          component: () => import("@/views/dietManagement/catering/IndexNew"),
          meta: {
            title: "营养配餐"
          }
        },
        {
          path: "/foodPrices",
          name: "foodPrices",
          component: () => import("@/views/dietManagement/foodPrice/foodPrice"),
          meta: {
            title: "食物价格管理"
          }
        },
        {
          path: "/allergy",
          name: "allergy",
          component: () => import("@/views/dietManagement/allergy/index"),
          meta: {
            title: "过敏管理"
          }
        },
        {
          path: "/personalDiet",
          name: "personalDiet",
          component: () =>
            import("@/views/dietManagement/personalDiet/dietSort"),
          meta: {
            title: "个人膳食管理"
          }
        },
        {
          path: "/kitchenInfo",
          name: "kitchenInfo",
          component: () => import("@/views/dietManagement/kitchenInfo/index"),
          meta: {
            title: "厨房信息管理"
          }
        },
        {
          path: "/tryDiet",
          name: "tryDiet",
          component: () => import("@/views/dietManagement/tryDiet/index"),
          meta: { title: "试吃管理" }
        },
        {
          path: "/dinner/:title",
          name: "dinner",
          component: () => import("@/views/dietManagement/dinner/index"),
          meta: { title: "幼儿用餐管理" }
        },
        {
          path: "/lunch",
          name: "lunch",
          component: () => import("@/views/dietManagement/lunch/index"),
          meta: { title: "午餐巡视" }
        },
        {
          path: "/lunch/detail",
          name: "lunchDetail",
          component: () => import("@/views/dietManagement/lunch/detail"),
          meta: { title: "午餐巡视情况" }
        },
      ]
    },
    {
      path: "/share",
      name: "share",
      component: () => import("@/views/dietManagement/share/Index"),
      meta: {
        title: "共享食谱"
      }
    },
    {
      path: "/foodPairing",
      name: "foodPairing",
      component: () => import("@/views/dietManagement/foodPairing/Index"),
      meta: {
        title: "配餐"
      }
    },
    {
      path: "/healthCare",
      name: "healthCare",
      component: Home,
      meta: {
        title: "卫生保健"
      },
      children: [
        {
          path: "/physical",
          name: "physical",
          component: () => import("@/views/healthCare/physical/Index"),
          meta: {
            title: "体检管理",
            keepAlive: true
          }
        },
        {
          path: "/tab",
          name: "tab",
          component: () =>
            import("@/views/healthCare/physical/childPhysical/tab"),
          meta: {
            title: "体检管理"
          }
        },
        {
          path: "/multipledetails",
          name: "multipledetails",
          component: () =>
            import("@/views/healthCare/physical/childPhysical/MultipleDetails"),
          meta: {
            title: "体检对比"
          }
        },
        {
          path: "/studentVision",
          name: "studentVision",
          component: () =>
            import("@/views/healthCare/physical/childPhysical/studentVision"),
          meta: {
            title: "视力标准值"
          }
        },
        {
          path: "/HealthCheck",
          name: "HealthCheck",
          component: () =>
            import("@/views/healthCare/physical/childCarePhysical/HealthCheck"),
          meta: {
            title: "儿保体检详情",
            keepAlive: true
          }
        },
        {
          path: "/HealthCheckDetails",
          name: "HealthCheckDetails",
          component: () =>
            import("@/views/healthCare/physical/childCarePhysical/Details"),
          meta: {
            title: "儿保体检详情"
          }
        },
        {
          path: "/detailsTeacher",
          name: "detailsTeacher",
          component: () =>
            import("@/views/healthCare/physical/teacherPhysical/Details"),
          meta: {
            title: "教职工体检详情"
          }
        },
        {
          path: "/physicalTest",
          name: "physicalTest",
          component: () => import("@/views/healthCare/physicalTest/index"),
          meta: {
            title: "体质测试"
          }
        },
        {
          path: "/analysis",
          name: "analysis",
          component: () => import("@/views/healthCare/analysis/index"),
          meta: {
            title: "体质分析",
            keepAlive: true
          }
        },
        {
          path: "/tjTable",
          name: "tjTable",
          component: () => import("@/views/healthCare/analysis/tjTable"),
          meta: {
            title: "体质分析"
          }
        },
        {
          path: "/hzTable",
          name: "hzTable",
          component: () => import("@/views/healthCare/analysis/hzTable"),
          meta: {
            title: "体质分析"
          }
        },
        {
          path: "/pjTable",
          name: "pjTable",
          component: () => import("@/views/healthCare/analysis/pjTable"),
          meta: {
            title: "体质分析"
          }
        },
        {
          path: "/bzTable",
          name: "bzTable",
          component: () => import("@/views/healthCare/analysis/bzTable"),
          meta: {
            title: "体质分析"
          }
        },
        // {
        //   path: '/childReport',
        //   name: 'childReport',
        //   components: () => import('@/views/healthCare/childReport/index'),
        //   meta: {
        //     title: '体检分析'
        //   },
        // },
        // {
        //   path: '/childReportTab',
        //   name: 'childReportTab',
        //   components: () => import('@/views/healthCare/childReport/childReportTab'),
        //   meta: {
        //     title: '体检分析'
        //   }
        // },
        {
          path: "/childReport",
          name: "childReportList",
          component: () =>
            import("@/views/healthCare/childReport/childReportList"),
          meta: {
            title: "体检分析",
            keepAlive: true
          }
        },
        {
          path: "/childHW",
          name: "childHW",
          component: () => import("@/views/healthCare/childReport/childHW"),
          meta: {
            title: "身高别体重统计表"
          }
        },
        {
          path: "/childHeight",
          name: "childHeight",
          component: () => import("@/views/healthCare/childReport/childHeight"),
          meta: {
            title: "年龄别身高统计表"
          }
        },
        {
          path: "/childWeight",
          name: "childWeight",
          component: () => import("@/views/healthCare/childReport/childWeight"),
          meta: {
            title: "年龄别体重统计表"
          }
        },
        {
          path: "/childEye",
          name: "childEye",
          component: () => import("@/views/healthCare/childReport/childEye"),
          meta: {
            title: "3-6岁儿童视力统计表"
          }
        },
        {
          path: "/childTJall",
          name: "childTJall",
          component: () => import("@/views/healthCare/childReport/childTJall"),
          meta: {
            title: "体检汇总表"
          }
        },
        {
          path: "/childTJallClass",
          name: "childTJallClass",
          component: () => import("@/views/healthCare/childReport/childTJallClass"),
          meta: {
            title: "班级体检分析表"
          }
        },
        {
          path: "/childFat",
          name: "childFat",
          component: () => import("@/views/healthCare/childReport/childFat"),
          meta: {
            title: "体弱儿名单"
          }
        },
        {
          path: "/childFocus",
          redirect: "/childFocus/0"
        },
        {
          path: "/childFocus/:id",
          name: "childFocus",
          component: () => import("@/views/healthCare/childFocus/childFocus"),
          meta: {
            title: "重点关注儿童",
            keepAlive: true
          }
        },
        {
          path: "/ObesityDetail",
          name: "ObesityDetail",
          component: () =>
            import("@/views/healthCare/childFocus/obesity/StuDetail"),
          meta: {
            title: "肥胖详情"
          }
        },
        {
          path: "/StandardValue",
          name: "StandardValue",
          component: () =>
            import("@/views/healthCare/childFocus/obesity/StandardValue"),
          meta: {
            title: "标准值"
          }
        },
        {
          path: "/StandardValueV2",
          name: "StandardValueV2",
          component: () =>
            import("@/views/healthCare/childFocus/obesity/StandardValueV2"),
          meta: {
            title: "标准值"
          }
        },
        {
          path: "/statisticalAnalysis",
          name: "statisticalAnalysis",
          component: () =>
            import("@/views/healthCare/statisticalAnalysis/Index"),
          meta: {
            title: "统计分析"
          }
        },
        {
          path: "/statisticalTab",
          name: "statisticalTab",
          component: () => import("@/views/healthCare/statisticalAnalysis/tab"),
          meta: {
            title: "统计分析"
          }
        },
        {
          path: "/growthRecord",
          name: "growthRecord",
          component: () => import("@/views/healthCare/growthRecord/index"),
          meta: {
            title: "成长记录"
          }
        },
        {
          path: "/DetailsSZCH",
          name: "DetailsSZCH",
          component: () =>
            import("@/views/healthCare/childFocus/grow/DetailsSZCH"),
          meta: {
            title: "生长迟缓"
          }
        },
        {
          path: "/EmaciationDetail",
          name: "EmaciationDetail",
          component: () =>
            import("@/views/healthCare/childFocus/emaciation/EmaciationDetail"),
          meta: {
            title: "消瘦"
          }
        },
        {
          path: "/anemiaDetail",
          name: "anemiaDetail",
          component: () =>
            import("@/views/healthCare/childFocus/anemia/anemiaDetail"),
          meta: {
            title: "贫血"
          }
        },
        {
          path: "/toothDetail",
          name: "toothDetail",
          component: () =>
            import("@/views/healthCare/childFocus/tooth/Details"),
          meta: {
            title: "龋齿"
          }
        },
        {
          path: "/visionDetail",
          name: "visionDetail",
          component: () =>
            import("@/views/healthCare/childFocus/vision/Details"),
          meta: {
            title: "视力"
          }
        },
        {
          path: "/LowWeightDetail",
          name: "LowWeightDetail",
          component: () =>
            import("@/views/healthCare/childFocus/lowweight/LowWeightDetail"),
          meta: {
            title: "低体重"
          }
        },
        {
          path: "/recovery",
          name: "recovery",
          component: () =>
            import("@/views/healthCare/childFocus/recovery/index"),
          meta: {
            title: "操作回收站"
          }
        }
      ]
    },
    {
      path: "/immune",
      name: "immune",
      component: Home,
      meta: {
        title: "计划免疫"
      },
      children: [
        {
          path: "/vaccine",
          name: "vaccine",
          component: () => import("@/views/immune/inspection/Index"),
          meta: {
            title: "疫苗查验",
            keepAlive: true
          }
        },
        {
          path: "/immuneDetails",
          name: "immuneDetails",
          component: () => import("@/views/immune/inspection/Details"),
          meta: {
            title: "疫苗查验"
          }
        },
        {
          path: "/vaccineDetails",
          name: "vaccineDetails",
          component: () => import("@/views/immune/details/Index"),
          meta: {
            title: "疫苗详情"
          }
        },
        {
          path: "/vaccineStatistics",
          name: "vaccineStatistics",
          component: () => import("@/views/immune/statistics/Index"),
          meta: {
            title: "疫苗统计"
          }
        }
      ]
    },
    {
      path: "/classLife",
      name: "classLife",
      component: Home,
      meta: {
        title: "班级生活"
      },
      children: [
        {
          path: "/classTime",
          name: "classTime",
          component: () => import("@/views/classLife/classTime/Index"),
          meta: {
            title: "班级时光"
          }
        },
        {
          path: "/colorfulLife",
          name: "colorfulLife",
          component: () => import("@/views/classLife/colorfulLife/Index"),
          meta: {
            title: "多彩生活"
          }
        }
      ]
    },
    //班级圈
    {
      path: "/classHome",
      name: "classHome",
      redirect: "/classHome/0",
      component: Home,
      meta: {
        title: "班级生活",
      },
      children: [
        {
          path: "/classHome/:id",
          name: "classCircle",
          component: () => import("@/views/classCircle/index"),
          meta: {
            title: "班级圈",
            keepAlive: true,
          }
        }, {
          path: "/classHome/:id/detail",
          name: "classDetail",
          component: () => import("@/views/classCircle/detail.vue"),
          meta: {
            title: "班级圈详情"
          }
        }, {
          path: "/classHome/:id/detailClock",
          name: "detailClock",
          component: () => import("@/views/classCircle/detailClock.vue"),
          meta: {
            title: "班级圈详情"
          }
        }, {
          path: "/classHome/:id/detailActive",
          name: "detailActive",
          component: () => import("@/views/classCircle/detailActive.vue"),
          meta: {
            title: "班级圈详情"
          }
        },
      ]
    },
    //基础信息
    {
      path: "/BasicInformation",
      name: "BasicInformation",
      component: Home,
      meta: {
        title: "基础信息"
      },
      children: [
        {
          path: "/classManagement",
          name: "classManagement",
          component: () =>
            import("@/views/basicInformation/classManagement/index"),
          meta: {
            title: "班级管理"
          }
        }, {
          path: "/changeClass",
          name: "changeClass",
          component: () =>
            import("@/views/basicInformation/classManagement/changeClass"),
          meta: {
            title: "临时调班"
          }
        },
        {
          path: "/childInformation",
          name: "childInformation",
          component: () =>
            import("@/views/basicInformation/childInformation/Index"),
          meta: {
            title: "学生信息"
          }
        },
        {
          path: "/statisticalBasic",
          name: "statisticalBasic",
          component: () =>
            import("@/views/basicInformation/statisticalBasic/index"),
          meta: {
            title: "统计分析"
          }
        },
        {
          path: "/studentAbsence",
          name: "studentAbsence",
          component: () =>
            import("@/views/basicInformation/studentAbsence/index"),
          meta: {
            title: "学生缺勤汇总"
          }
        },
        {
          path: "/department",
          name: "department",
          component: () => import("@/views/basicInformation/department/index"),
          meta: {
            title: "部门管理"
          }
        },
        {
          path: "/teacherStatistic",
          name: "teacherStatistic",
          component: () =>
            import("@/views/basicInformation/teacherStatistic/index"),
          meta: {
            title: "教师统计分析"
          }
        },
        {
          path: "/historyClass",
          name: "historyClass",
          component: () =>
            import("@/views/basicInformation/historyClass/index"),
          meta: {
            title: "历史班级"
          }
        }
      ]
    },
    //工作规范
    {
      path: "/workNorm",
      name: "workNorm",
      component: Home,
      meta: {
        title: "工作规范"
      },
      children: [
        {
          path: "/normTotal",
          name: "normTotal",
          component: () => import("@/views/workNorm/workTotal/normTotal"),
          meta: {
            title: "规范总则"
          }
        },
        {
          path: "/facultyHealth",
          name: "facultyHealth",
          component: () =>
            import("@/views/workNorm/facultyHealth/facultyHealth"),
          meta: {
            title: "教职工健康检测"
          }
        },
        {
          path: "/commonill",
          name: "commonill",
          component: () => import("@/views/workNorm/commonill/commonill"),
          meta: {
            title: "常见病鉴别和处理"
          }
        },
        {
          path: "/infectiousIll",
          name: "infectiousIll",
          component: () =>
            import("@/views/workNorm/infectiousIll/infectiousIll"),
          meta: {
            title: "传染病鉴别和处理"
          }
        },
        {
          path: "/accidents",
          name: "accidents",
          component: () => import("@/views/workNorm/accidents/accidents"),
          meta: {
            title: "意外情况"
          }
        },
        {
          path: "/tableSet",
          name: "tableSet",
          component: () => import("@/views/workNorm/tableSet/tableSet"),
          meta: {
            title: "表格管理"
          }
        }
      ]
    },

    //设置
    {
      path: "/systemSet",
      name: "systemSet",
      component: Home,
      meta: {
        title: "系统设置"
      },
      children: [
        {
          path: "/pushSet",
          name: "pushSet",
          component: () => import("@/views/systemSet/pushSet/Index"),
          meta: {
            title: "服药管理"
          }
        },
        {
          path: "/drugSet",
          name: "drugSet",
          component: () => import("@/views/systemSet/drugSet/drug"),
          meta: {
            title: "服药管理"
          }
        },
        {
          path: "/setAttendance",
          name: "setAttendance",
          component: () => import("@/views/systemSet/setAttendance/index"),
          meta: {
            title: "出勤管理"
          }
        },
        {
          path: "/setDiet",
          name: "setDiet",
          component: () => import("@/views/systemSet/setDiet/dietTime"),
          meta: {
            title: "膳食管理"
          }
        },
        {
          path: "/semester",
          name: "semester",
          hidden: true,
          component: () => import("@/views/systemSet/semester/index"),
          meta: {
            title: "学期设置"
          }
        },
        {
          path: "/setSemester",
          name: "setSemester",
          hidden: true,
          component: () => import("@/views/systemSet/semester/semester"),
          meta: {
            title: "学期设置"
          }
        },
        {
          path: "/SchoolTime",
          name: "SchoolTime",
          hidden: true,
          component: () => import("@/views/systemSet/semester/schoolTime"),
          meta: {
            title: "学期设置"
          }
        },
        {
          path: "/jurisdiction",
          name: "jurisdiction",
          component: () => import("@/views/systemSet/roleJurisdiction/index"),
          meta: {
            title: "角色管理"
          }
        },
        {
          path: "/setPower",
          name: "setPower",
          component: () => import("@/views/systemSet/roleJurisdiction/setRole"),
          meta: {
            title: "编辑权限"
          }
        },
        {
          path: "/setApplet",
          name: "setApplet",
          component: () =>
            import("@/views/systemSet/roleJurisdiction/setApplet"),
          meta: {
            title: "小程序权限"
          }
        },
        {
          path: "/placeMenagement",
          name: "placeMenagement",
          component: () => import("@/views/systemSet/placeMenagement/index"),
          meta: {
            title: "场所管理",
            keepAlive: true
          }
        },
        {
          path: "/placeDetail",
          name: "placeDetail",
          component: () => import("@/views/systemSet/placeMenagement/detail"),
          meta: {
            title: "场所详情"
          }
        },
        {
          path: "/setAttendanceRule",
          name: "setAttendanceRule",
          hidden: true,
          component: () =>
            import("@/views/systemSet/teacherAttendance/indexNew"),
          meta: {
            title: "教师考勤设置",
            keepAlive: true
          }
        },
        {
          path: "/setGates",
          name: "setGates",
          hidden: true,
          component: () => import("@/views/systemSet/setGates/Index"),
          meta: {
            title: "匝道时间段设置",
            keepAlive: true
          }
        },
        {
          path: "/schoolMenu",
          name: "schoolMenu",
          hidden: true,
          component: () => import("@/views/systemSet/schoolMenu/Index"),
          meta: {
            title: "小程序家长菜单",
            keepAlive: true
          }
        },
        {
          path: "/disinfectAdmin",
          name: "disinfectAdmin",
          component: () => import("@/views/systemSet/disinfectAdmin/index"),
          meta: {
            title: "消毒管理"
          }
        },
        {
          path: "/uploadSchoolPhoto",
          name: "uploadSchoolPhoto",
          component: () => import("@/views/systemSet/uploadSchoolPhoto/index"),
          meta: {
            title: "大屏设置"
          }
        },
        {
          path: "/jobtitleMenu",
          name: "jobtitleMenu",
          component: () => import("@/views/systemSet/jobtitleJurisdiction/index"),
          meta: {
            title: "职务权限管理"
          }
        },
        {
          path: "/setjtPower",
          name: "setjtPower",
          component: () => import("@/views/systemSet/jobtitleJurisdiction/setRole"),
          meta: {
            title: "PC职务权限"
          }
        },
        {
          path: "/setjtApplet",
          name: "setjtApplet",
          component: () =>
            import("@/views/systemSet/jobtitleJurisdiction/setApplet"),
          meta: {
            title: "小程序职务权限"
          }
        },
      ]
    },
    //消息
    {
      path: "/news",
      name: "news",
      component: Home,
      meta: {
        title: "消息"
      },
      children: [
        {
          path: "/account",
          name: "account",
          component: () => import("@/views/allNews/accountNews/index"),
          meta: {
            title: "账号信息"
          }
        },
        {
          path: "/classNews",
          name: "classNews",
          component: () => import("@/views/allNews/classNews/index"),
          meta: {
            title: "班级消息"
          }
        },
        {
          path: "/classNewsDetial",
          name: "classNewsDetial",
          component: () => import("@/views/allNews/classNews/details"),
          meta: {
            title: "班级消息详情"
          }
        },
        {
          path: "/schoolNews",
          name: "schoolNews",
          component: () => import("@/views/allNews/schoolNews/index"),
          meta: {
            title: "学校公告"
          }
        },
        {
          path: "/schoolDetail",
          name: "schoolDetail",
          component: () => import("@/views/allNews/schoolNews/Details"),
          meta: {
            title: "学校公告详情"
          }
        },
        {
          path: "/schoolNotice",
          name: "schoolNotice",
          component: () => import("@/views/allNews/schoolNews/AddNotice"),
          meta: {
            title: "发布公告"
          }
        }
      ]
    },
    //园长端
    {
      path: "/headEnd",
      name: "headEnd",
      component: () => import("@/statistics/views/Home"),
      meta: {
        title: "首页"
      },
      children: [
        {
          path: "/homepage",
          name: "homepage",
          component: () => import("@/statistics/views/homepage/Index"),
          meta: {
            title: "预警主屏",
            role: false
          }
        },
        {
          path: "/countyDatas",
          name: "countyDatas",
          component: () => import("@/statistics/views/countyDatas/Index"),
          meta: {
            title: "预警主屏",
            role: false
          }
        },
        {
          path: "/citydatas",
          name: "citydatas",
          component: () => import("@/statistics/views/cityDatas/Index"),
          meta: {
            title: "预警主屏",
            role: false
          }
        },
        {
          path: "/datas",
          name: "datas",
          component: () => import("@/statistics/views/datas/Index"),
          meta: {
            title: "数据总览",
            role: true
          }
        },
        {
          path: "/attendanceScreen",
          name: "attendanceScreen",
          component: () => import("@/statistics/views/attendance/Index"),
          meta: {
            title: "考勤分析",
            role: true
          }
        },
        {
          path: "/vaccineScreen",
          name: "vaccineScreen",
          component: () => import("@/statistics/views/vaccine/Index"),
          meta: {
            title: "疫苗分析",
            role: true
          }
        },
        {
          path: "/morningCheckScreen",
          name: "morningCheckScreen",
          component: () => import("@/statistics/views/morningCheck/Index"),
          meta: {
            title: "晨检分析",
            role: true
          }
        }
      ]
    },
    //分园管理
    {
      path: "/branchGarden",
      name: "branchGarden",
      component: Home,
      meta: {
        title: "分园管理"
      },
      children: [
        {
          path: "/listOfSubParks",
          name: "listOfSubParks",
          component: () => import("@/views/branchGarden/listOfSubParks/index"),
          meta: {
            title: "分园列表"
          }
        },
        {
          path: "/gardenRole",
          name: "gardenRole",
          component: () => import("@/views/branchGarden/gardenRole/index"),
          meta: {
            title: "分园角色管理"
          }
        },
        {
          path: "/gardenRoleDetail",
          name: "gardenRoleDetail",
          component: () =>
            import("@/views/branchGarden/gardenRole/gardenRoleDetail"),
          meta: {
            title: "分园角色管理"
          }
        },
        {
          path: "/gardenRolePower",
          name: "gardenRolePower",
          component: () =>
            import("@/views/branchGarden/gardenRole/gardenRolePower"),
          meta: {
            title: "分园角色权限"
          }
        },
        {
          path: "/gardenAppletPower",
          name: "gardenAppletPower",
          component: () =>
            import("@/views/branchGarden/gardenRole/gardenAppletPower"),
          meta: {
            title: "分园角色小程序权限"
          }
        },
        {
          path: "/branchAdministrator",
          name: "branchAdministrator",
          component: () =>
            import("@/views/branchGarden/branchAdministrator/index"),
          meta: {
            title: "分园管理员"
          }
        }
      ]
    },
    {
      path: "/applyBranchPark",
      name: "applyBranchPark",
      component: () => import("@/views/branchGarden/applyBranchPark/index"),
      meta: {
        title: "分园申请",
        notLogin: true
      }
    },
    {
      path: "/healthReports/:title",
      name: "healthReports",
      component: () => import("@/views/healthReports"),
      meta: {
        title: "统计分析"
      }
    },
    {
      path: "/classReport/detail",
      name: "healthDetail",
      component: () => import("@/views/healthReports/detail/index"),
      meta: {
        title: "学生个人详情"
      }
    },
    {
      path: "/mobile",
      name: "mobile",
      component: moHome,
      hidden: true,
      children: [{
        path: "/mobile/liveStreaming",
        name: "liveStreaming",
        component: () => import("@/mobile/liveStreaming"),
        meta: {
          title: "云呵护直播间",
          notLogin: true
        }
      }, {
        path: "/mobile/preview",
        name: "preview",
        component: () => import("@/mobile/liveStreaming/preview"),
        meta: {
          title: "直播预告",
          notLogin: true
        }
      }, {
        path: "/mobile/lookback",
        name: "lookback",
        component: () => import("@/mobile/liveStreaming/lookback"),
        meta: {
          title: "回看列表",
          notLogin: true
        }
      }, {
        path: "/mobile/report",
        name: "mobileReport",
        component: () => import("@/mobile/report/index"),
        meta: {
          title: "使用申请",
          notLogin: true
        }
      }, {
        path: "/mobile/report/success",
        name: "mobileReportSuccess",
        component: () => import("@/mobile/report/success"),
        meta: {
          title: "申请成功",
          notLogin: true
        }
      }, {
        path: "/mobile/report/info",
        name: "mobileReportInfo",
        component: () => import("@/mobile/report/info"),
        meta: {
          title: "平台介绍",
          notLogin: true
        }
      }]
    },
    {
      path: "/expressionTraining",
      name: "expressionTraining",
      component: Home,
      children: [{
        path: "/expressionTraining/index",
        name: "expressionTraining",
        component: () => import("@/views/dietManagement/expressionTraining/index"),
        meta: {
          title: "语言表达训练",
        }
      }, {
        path: "/expressionTraining/classInfo",
        name: "trainingClassInfo",
        component: () => import("@/views/dietManagement/expressionTraining/classInfo"),
        meta: {
          title: "班级详情",
        }
      }, {
        path: "/expressionTraining/studentInfo",
        name: "trainingStudentInfo",
        component: () => import("@/views/dietManagement/expressionTraining/studentInfo"),
        meta: {
          title: "学生详情",
        }
      }, {
        path: "/expressionTraining/trainingInfo",
        name: "trainingInfo",
        component: () => import("@/views/dietManagement/expressionTraining/trainingInfo"),
        meta: {
          title: "记录详情",
        }
      }, {
        path: "/expressionTraining/topics",
        name: "trainingTopic",
        component: () => import("@/views/dietManagement/expressionTraining/topics"),
        meta: {
          title: "管理主题",
        }
      }, {
        path: "/expressionTraining/topicInfo",
        name: "trainingTopicInfo",
        component: () => import("@/views/dietManagement/expressionTraining/topicInfo"),
        meta: {
          title: "主题详情",
        }
      },]
    },
    {
      path: "/aiResources",
      name: "aiResources",
      component: Home,
      children: [{
        path: "/aiResources",
        name: "aiResources",
        redirect: "/aiResources/music",
        component: () => import("@/views/daily/aiResources/index"),
        meta: {
          title: "AI资源库",
        },
        children: [{
          path: "/aiResources/music",
          name: "music",
          component: () => import("@/views/daily/aiResources/music"),
          meta: {
            title: "AI音乐库",
          }
        }, {
          path: "/aiResources/story",
          name: "story",
          component: () => import("@/views/daily/aiResources/story"),
          meta: {
            title: "AI故事库",
          }
        }, {
          path: "/aiResources/story/:id",
          name: "storyDetail",
          component: () => import("@/views/daily/aiResources/storyDetail"),
          meta: {
            title: "AI资源详情",
            activeMenu: "story",
          }
        },]
      },]
    },
    {
      path: "/lifeCare",
      name: "lifeCare",
      component: Home,
      children: [{
        path: "/lifeCare",
        name: "lifeCare",
        component: () => import("@/views/daily/lifeCare/index"),
        meta: {
          title: "生活照顾",
          keepAlive: true,
        },
      }, {
        path: "/lifeCare/list",
        name: "lifeCareList",
        component: () => import("@/views/daily/lifeCare/list"),
        meta: {
          title: "生活照顾",
          keepAlive: true,
        },
      }, {
        path: "/lifeCare/detail",
        name: "lifeCareDetail",
        component: () => import("@/views/daily/lifeCare/detail"),
        meta: {
          title: "生活照顾详情",
        },
      }]
    },
    {
      path: "/aisports",
      name: "aisports",
      component: Home,
      children: [{
        path: "/aisports",
        name: "aisports",
        component: () => import("@/views/daily/Bjb/Index"),
        meta: {
          title: "AI智趣体育",
          keepAlive: true,
        },
      }, {
        path: "/aisports/rank",
        name: "aisportsRank",
        component: () => import("@/views/daily/Bjb/SportRank"),
        hidden: true,
        meta: {
          title: "AI智趣体育排名",
          keepAlive: true,
        },
      }, {
        path: "/aisports/record",
        name: "aisportsRecord",
        component: () => import("@/views/daily/Bjb/SportRecord"),
        hidden: true,
        meta: {
          title: "AI智趣体育记录",
        },
      }]
    },
    {
      path: "/dataV",
      name: "dataV",
      component: () => import("@/views/dataV/index"),
      meta: {
        title: "云呵护学校卫生保健管理数字驾驶舱"
      }
    },
  ],
  linkActiveClass: "active",
  scrollBehavior(to, from, savePosition) {
    // console.log('savePosition', savePosition)
    if (savePosition) {
      return savePosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// 使用 router.beforeEach 注册一个全局前置守卫，判断用户是否登陆
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (!to.meta.notLogin) {
    let token = localStorage.getItem("loginToken") || "";
    let timestamp = new Date().getTime();
    let expires = localStorage.getItem("tokenExpires") || 0;
    // console.log(token, expires)
    if (token && expires > timestamp) {
      next();
    } else {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      });
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js